import React from "react";
import Form from "../components/form/Form";
import List from "../components/list/List";

const TodoList = () => {
  return (
    <div>
      <Form />
      <List />
    </div>
  );
};

export default TodoList;
